import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export const AnimatedCounter = ({ end, duration = 2, suffix = '', prefix = '' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = (timestamp - startTime) / (duration * 1000);

      if (progress < 1) {
        setCount(Math.floor(end * progress));
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration]);

  return (
    <span>
      {prefix}
      {count}
      {suffix}
    </span>
  );
};

export const StatsCard = ({ stat, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-card border-2 border-border rounded-lg lg:p-8 p-4 text-center hover:border-primary transition-all duration-300 hover:shadow-lg group"
    >
      <div className="text-5xl mb-5 transform group-hover:scale-110 transition-transform">
        {stat.icon}
      </div>
      <div className="text-4xl sm:text-3xl font-heading font-semibold text-primary mb-2">
        <AnimatedCounter end={parseInt(stat.total)} suffix={stat.total.replace(/[0-9]/g, '')} />
      </div>
      <p className="text-md font-semibold text-foreground mb-1">{stat.title}</p>
      <p className="text-sm text-muted-foreground">{stat.description}</p>
    </motion.div>
  );
};
